import { createPhoneCall } from '@/services/api/voiceApi'
import { FEATURES } from '@/constants/features'
import { POSTHOG_FLAGS } from '@/constants/posthogFlags'
import { canAccessFeature } from '@/utils/access'
import { isPostHogFlagEnabled } from '@/utils/posthogFlags'

export const PHONE_CALL_NOTICE = 'Starting a phone call creates a Phone Call work record for this patient.'

export function canStartPhoneCall() {
  return canAccessFeature(FEATURES.COMPONENT_TELEHEALTH_PHONE)
    && isPostHogFlagEnabled(POSTHOG_FLAGS.TELEHEALTH_THREE_WAY_CALLING)
}

export function phoneCallPath(workId) {
  return `/work/phonecall/${workId}`
}

export async function startPhoneCall({ opportunityId, taskId }) {
  if (!taskId) throw new Error('A task is required to start a phone call.')
  const tab = window.open('', '_blank')
  try {
    const body = { task_id: taskId }
    if (opportunityId) body.opportunity_id = opportunityId
    const phoneCall = await createPhoneCall(body)
    const path = phoneCallPath(phoneCall.work_id)
    if (tab) tab.location.href = path
    else window.open(path, '_blank')
    return phoneCall
  } catch (error) {
    tab?.close()
    throw error
  }
}
